import { getComponentData } from 'pages/ComponentBuilder'

export default {
    getComponentData,
    liquidVariables: (state) => {
        return {
            ...state.products
        }
    }
}